var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"wrapper"},[_c('div',{attrs:{"id":this.containerId}}),_c('div',{staticClass:"horizontal-bar",class:{ hidden: !_vm.ready },style:(`--base-color: ${_vm.baseColor}`)})])
}
var staticRenderFns = []

export { render, staticRenderFns }